import { axiosAssessmentInstance } from "../AxiosConfiguration";

export const getElementsOverview = async () => {
  try {
    const response = await axiosAssessmentInstance.get("/api/elements/overview");
    return response?.data?.payload || null;
  } catch (error) {
    console.error("Error fetching elements overview:", error);
    throw error;
  }
};

export const markElementViewed = async (elementKey) => {
  if (!elementKey) return null;
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/v2/assessment/elements/${encodeURIComponent(elementKey)}/view`
    );
    return response?.data?.payload || null;
  } catch (error) {
    console.error("Error marking element viewed:", error);
    return null;
  }
};
